import {Component, OnInit} from '@angular/core';
import {DashboardLayersGeoBaseControlComponent} from '../dashboard-layers-geo-base-control.component';
import {GeoItemId} from '../../../../shared/types/geo-item-id.type';
import {geofenceType} from '../../../../shared/constants/geofence-type.constant';
import {debounceTime, distinctUntilChanged, filter} from 'rxjs/operators';
import {combineLatest, Observable} from 'rxjs';
import {LatLngBounds} from 'leaflet';
import {ProjectBusinessLogicFilterModel} from '../../../../shared/project-business-logic-filter/project-business-logic-filter.model';

@Component({
  selector: 'app-dashboard-layers-geo-objects-control',
  templateUrl: '../dashboard-layers-geo-base-control.component.html',
})
export class DashboardLayersGeoObjectsControlComponent extends DashboardLayersGeoBaseControlComponent implements OnInit {
  useStorage = false;
  minZoomForGeopoints = 10;
  visibleItems: GeoItemId[] = [
    'regions', 'demand', 'tech_work_area', 'geopoints', 'geofences',
    geofenceType.RIDE_ALLOW,
    geofenceType.RIDE_RESTRICT,
    geofenceType.FINISH_ALLOW,
    geofenceType.FINISH_RESTRICT,
    geofenceType.SPEED_LIMIT,
  ];

  getRefreshTrigger(): Observable<[number, LatLngBounds, ProjectBusinessLogicFilterModel]> {
    return combineLatest([
      this.mapZoom,
      this.leafletBoundaryBox.pipe(
        distinctUntilChanged((a, b) => {
          const aSW = a.getSouthWest();
          const aNE = a.getNorthEast();
          const bSW = b.getSouthWest();
          const bNE = b.getNorthEast();

          return (
            aSW.lat === bSW.lat &&
            aSW.lng === bSW.lng &&
            aNE.lat === bNE.lat &&
            aNE.lng === bNE.lng
          );
        })
      ),
      this.projectBusinessLogicSyncFilterService.getFormattedProjectBusinessLogicFilter()
    ]).pipe(
      filter(([zoom, bbox]) => !!(zoom && bbox)),
      debounceTime(500),
    ) as Observable<[number, LatLngBounds, ProjectBusinessLogicFilterModel]>;
  }

  ngOnInit() {
    super.ngOnInit();

    this.subscriptions.push(
      this.mapLayersService.refreshLayers
        .subscribe(() => {
          this.dashboardGeofenceService.clearCache();
          this.loadMapGeoData(true);
        })
    );
  }
}
